import CryptoAes from 'crypto-js/aes';
import CryptoEncUtf8 from 'crypto-js/enc-utf8';

const ENCRYPT_KEY = 'kakaowebtoon-encrypt-key';

export function encryptVariables(rawString: string) {
  return CryptoAes.encrypt(rawString, ENCRYPT_KEY).toString();
}

export function decryptVariables(encryptedString: string) {
  return JSON.parse(
    CryptoAes.decrypt(encryptedString, ENCRYPT_KEY).toString(CryptoEncUtf8)
  );
}
